export default __webpack_public_path__ + "static/media/image-14.57b8dd00.webp";